<template>
    <div class="grid grid-cols-12 gap-6 mt-6">
        <div class="col-span-12">
            <h3 class="text-xl font-bold leading-none mt-5 text-custom-member">
                ประกาศ
            </h3>
        </div>
        <div class="col-span-12">
            <div class="grid grid-cols-12 gap-6">
                <NewsList :news-section="data" v-for="(data,key) in newsSection" :key="key"/>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent, reactive } from 'vue'
import NewsList from "./NewsList.vue"
export default defineComponent({
    components:{
        NewsList
    },
    setup(){
        const newsSection = reactive([
            { text: "เกี่ยวกับโครงการ" },
            { text: "เกี่ยวกับระบบ" },
            { text: "ข่าวสาร/ประกาศอื่น" },
        ]);
        return {
            newsSection
        }
    }
})
</script>

<style>

</style>